/**
 * Shopping-list price delta: up is bad (red), down is good (green).
 * @param {number} formerPricePence - previous price in pence
 * @param {number} currentPricePounds - current price in pounds
 * @returns {{ symbol: '▲' | '▼', tone: 'red' | 'green' }}
 */
export function getPriceChangeIndicator(formerPricePence, currentPricePounds) {
  const formerPounds = Number(formerPricePence) / 100
  const currentPounds = Number(currentPricePounds)

  if (formerPounds > currentPounds) {
    return { symbol: '▼', tone: 'green' }
  }

  return { symbol: '▲', tone: 'red' }
}
